import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TopNavBar from '../dashboard/components/TopNavBar';
import AccessManagement from '../dashboard/components/AccessManagement';
import NavigationPreventer from '../../components/NavigationPreventer';
import { useAuth } from '../../state/auth/useAuth';

const UsersPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('patients');

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    switch(tabId) {
      case 'dashboard':
        navigate('/dashboard');
        break;
      case 'master-data':
        navigate('/admin/dashboard');
        break;
      case 'patients':
        // Stay on users/patients page
        break;
      case 'inventory':
        navigate('/inventory');
        break;
      case 'reports':
        navigate('/accounting');
        break;
      case 'finance':
        navigate('/finance');
        break;
      case 'settings':
        navigate('/hospital-settings');
        break;
      case 'profile':
        console.log('Profile navigation - route not yet configured');
        break;
      default:
        break;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50" style={{ fontFamily: 'Poppins' }}>
      <NavigationPreventer />
      <TopNavBar 
        user={user}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />
      <main className="pt-20 px-4 lg:px-6">
        <div className="space-y-4">
          {/* Header */}
          <div className="bg-white rounded-xl border-2 border-gray-200 shadow-sm p-5">
            <h1 className="text-2xl font-bold text-gray-900 mb-1">
              User Management
            </h1>
            <p className="text-sm text-gray-600">
              Manage system users, roles, permissions, and access control
            </p>
          </div>

          {/* Access Management Content with Tabs */}
          <AccessManagement />
        </div>
      </main>
    </div>
  );
};

export default UsersPage;